import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Impostazioni',
  lead: 'Il profilo della tua azienda, il branding e le impostazioni sulla privacy.',
  noCompany: 'Nessuna azienda attiva selezionata.',
  adminOnly:
    'Solo un amministratore della piattaforma può modificare questo — puoi vedere i valori attuali.',
  save: 'Salva',
  nav: {
    label: 'Menu impostazioni',
    profile: 'Profilo',
    branding: 'Branding',
    privacy: 'Privacy',
    modules: 'Moduli',
  },
  profile: {
    title: 'Profilo',
    name: "Nome dell'organizzazione",
    industry: 'Settore',
    industryHint: 'Testo libero, ad es. "Logistica" o "Sanità".',
    employeeCount: 'Numero di dipendenti',
    plan: 'Piano',
    planPlaceholder: 'Vedi Abbonamento',
  },
  branding: {
    title: 'Branding',
    lead: "Il tuo logo e colore accento, con un'anteprima dal vivo.",
    logo: 'Carica logo',
    logoHint: 'Caricato subito; oppure inserisci un URL esistente qui sotto.',
    logoUrl: 'URL del logo',
    upload: {
      uploading: 'Caricamento in corso…',
      tooLarge: 'Il file è troppo grande (max 10MB).',
      invalidType: 'Tipo di file non consentito.',
    },
    accentColor: 'Colore accento',
    preview: 'Anteprima dal vivo',
    colors: {
      mint: 'Menta',
      pine: 'Pino',
      ink: 'Inchiostro',
      amber: 'Ambra',
      coral: 'Corallo',
      sky: 'Cielo',
    },
  },
  privacy: {
    title: 'Privacy',
    lead: 'La dimensione minima del gruppo per le statistiche aggregate e cosa condivide la tua azienda.',
    minGroupSize: 'Dimensione minima del gruppo (k-anonimato)',
    minGroupSizeHint:
      'Al di sotto di questo valore, un gruppo è troppo piccolo per mostrare statistiche aggregate.',
    minGroupSizeValue: '{{count}} persone',
    effective: 'Attualmente in vigore: {{count}} persone',
    aggregatedData: 'Dati aggregati',
    aggregatedDataHint:
      'Mostra statistiche aggregate per i gruppi che raggiungono la dimensione minima.',
    explicitConsent: 'Consenso esplicito richiesto',
    explicitConsentHint:
      'Richiedi una risposta di consenso individuale anziché un consenso collettivo.',
    dataExport: 'Esportazione dati',
    dataExportHint: "Consenti l'esportazione dei dati statistici.",
    auditLogHint: 'Le azioni amministrative vengono sempre registrate in un registro di controllo.',
  },
  modules: {
    title: 'Moduli',
    lead: 'Attiva o disattiva i moduli disponibili per la tua azienda.',
    vitality: 'Vitalità',
    vitalityHint: "Monitoraggio del sonno, dello stress, della frequenza cardiaca e dell'attività.",
    participation: 'Partecipazione',
    participationHint: 'Funnel di engagement e metriche di partecipazione.',
    pilots: 'Piloti',
    pilotsHint: 'Esegui e monitora i programmi pilota.',
    challenges: 'Sfide',
    challengesHint: 'Crea e gestisci le sfide di benessere.',
    communication: 'Comunicazione',
    communicationHint: 'Invia notifiche e messaggi ai dipendenti.',
    documents: 'Documenti',
    documentsHint: 'Pubblica e gestisci i documenti aziendali.',
    reports: 'Rapporti',
    reportsHint: 'Genera ed esporta rapporti analitici.',
    ai_coach: 'Coach IA',
    ai_coachHint: 'Coaching personalizzato basato su intelligenza artificiale.',
  },
};
